import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-klasse-zehn-cit-page',
  templateUrl: './klasse-zehn-cit-page.component.html',
  styleUrls: ['./klasse-zehn-cit-page.component.css']
})
export class KlasseZehnCitPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
